module.exports = __webpack_public_path__ + "static/bitget-logo-e71fc73a82312056ac775691af378a6f.webp";